import { Action, createReducer, on } from '@ngrx/store';
import { ListItem } from 'src/app/shared/models/list-item.model';
import {
    Attachment,
    DeclineReasons,
    OfferDetailsRecruiting,
    OfferNotes,
    VendorOptions
} from 'src/app/shared/models/offers.model';
import { OfferMarginDifference } from 'src/app/shared/offers-shared/offer-details/dialog-offer-margin-differences/model/offer-margin-difference.model';
import * as fromActions from '../actions';

export interface DealDetailsState {
    isLoading: boolean;
    details: OfferDetailsRecruiting;
    marginDifferences: OfferMarginDifference[];
    notes: OfferNotes[];
    attachments: Attachment[];
    declineReasons: DeclineReasons[];
    vendorSearch: VendorOptions[];
    facilitySearch: ListItem[];
    error: unknown;
}

export const initialDealDetailsState: DealDetailsState = {
    isLoading: false,
    marginDifferences: [],
    details: null,
    notes: [],
    attachments: [],
    declineReasons: [],
    vendorSearch: [],
    facilitySearch: [],
    error: undefined
};

export function dealDetailsReducer(state: DealDetailsState, action: Action) {
    return createReducer(
        initialDealDetailsState,

        on(
            fromActions.RecruitingActions.DealDetailsActions.getDetails,
            fromActions.RecruitingActions.DealDetailsActions.getOfferNotes,
            fromActions.RecruitingActions.DealDetailsActions.getAttachments,
            fromActions.RecruitingActions.DealDetailsActions.postAttachment,
            fromActions.RecruitingActions.DealDetailsActions.updateAttachment,
            fromActions.RecruitingActions.DealDetailsActions.getAttachmentBlob,
            fromActions.RecruitingActions.DealDetailsActions.deleteAttachment,
            fromActions.RecruitingActions.DealDetailsActions.getDeclineReasons,
            fromActions.RecruitingActions.DealDetailsActions.vendorSearch,
            fromActions.RecruitingActions.DealDetailsActions.facilitySearch,
            (state, action) => ({
                ...state,
                isLoading: true
            })
        ),

        on(
            fromActions.RecruitingActions.DealDetailsActions.getDetailsFailure,
            fromActions.RecruitingActions.DealDetailsActions.getOfferNotesFailure,
            fromActions.RecruitingActions.DealDetailsActions.getAttachmentsFailure,
            fromActions.RecruitingActions.DealDetailsActions.postAttachmentFailure,
            fromActions.RecruitingActions.DealDetailsActions.updateAttachmentFailure,
            fromActions.RecruitingActions.DealDetailsActions.getAttachmentBlobFailure,
            fromActions.RecruitingActions.DealDetailsActions.getDeclineReasonsFailure,
            fromActions.RecruitingActions.DealDetailsActions.vendorSearchFailure,
            fromActions.RecruitingActions.DealDetailsActions.facilitySearchFailure,
            (state, action) => ({
                ...state,
                isLoading: false,
                error: JSON.stringify(action.error)
            })
        ),

        on(fromActions.RecruitingActions.DealDetailsActions.getDetailsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            details: action.details,
            marginDifferences: action.difference
        })),

        on(fromActions.RecruitingActions.DealDetailsActions.getOfferNotesSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            notes: action.notes
        })),

        on(fromActions.RecruitingActions.DealDetailsActions.getAttachmentsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            attachments: action.attachments
        })),

        on(
            fromActions.RecruitingActions.DealDetailsActions.postAttachmentSuccess,
            fromActions.RecruitingActions.DealDetailsActions.updateAttachmentSuccess,
            fromActions.RecruitingActions.DealDetailsActions.deleteAttachmentSuccess,
            fromActions.RecruitingActions.DealDetailsActions.getAttachmentBlobSuccess,
            (state) => ({
                ...state,
                isLoading: false
            })
        ),

        on(fromActions.RecruitingActions.DealDetailsActions.getDeclineReasonsSuccess, (state, action) => ({
            ...state,
            declineReasons: action.declineReasons
        })),

        on(fromActions.RecruitingActions.DealDetailsActions.vendorSearchSuccess, (state, action) => ({
            ...state,
            vendorSearch: action.vendorSearch
        })),

        on(fromActions.RecruitingActions.DealDetailsActions.facilitySearchSuccess, (state, action) => ({
            ...state,
            facilitySearch: action.facilitySearch
        })),

        on(
            fromActions.RecruitingActions.DealDetailsActions.setOfferDetailAsVerballyAcceptedSuccess,
            (state, action) => ({
                ...state,
                details: {
                    ...state.details,
                    offerVerballyAccepted: true
                }
            })
        )
    )(state, action);
}

export function reducer(state: DealDetailsState | undefined, action: Action) {
    return dealDetailsReducer(state, action);
}
